<template>
  <div>
    <v-menu
      v-if="$auth.user().id && !isMobile"
      v-model="menu"
      content-class="app-menu"
      offset-y
      right
      min-width="300"
      :close-on-content-click="false"
    >
      <template #activator="{ on }">
        <a v-on="on">
          <user-menu-activator />
        </a>
      </template>

      <v-card>
        <v-list>
          <user-menu-content :items="items" @close="closeMenu" />
        </v-list>
      </v-card>
    </v-menu>

    <v-list v-if="$auth.user() && $auth.user().id && isMobile" class="py-0">
      <v-list-group v-model="menu">
        <template #activator>
          <user-menu-activator />
        </template>
        <v-divider class="mx-4 mt-2" />

        <user-menu-content :items="items" @close="closeMenu" />
      </v-list-group>
    </v-list>

    <change-password-dialog v-model="showChangePasswordDialog" />
  </div>
</template>

<script>
import UserMenuContent from '@/modules/User/components/UserMenuContent';
import UserMenuActivator from '@/modules/User/components/UserMenuActivator';
import { NAMESPACE as AUTHENTICATION_NAMESPACE } from '@/modules/Authentication/store';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'UserMenu',

  components: {
    UserMenuActivator,
    UserMenuContent,
    ChangePasswordDialog: () =>
      import(
        '@/modules/User/components/ChangePasswordDialog' /* webpackChunkName: "ChangePasswordDialog" */
      )
  },

  data: () => ({
    menu: false
  }),

  computed: {
    ...mapState(AUTHENTICATION_NAMESPACE, ['current']),
    items() {
      return [
        {
          title: 'user.viewMasterData',
          to: this.routeName.MASTER_DATA,
          condition: this.permissions.navigation[this.routeName.MASTER_DATA]
        },
        {
          title: 'settings.title',
          to: this.routeName.SETTINGS,
          condition: this.permissions.navigation[this.routeName.SETTINGS]
        },
        {
          title: 'user.changePassword',
          action: () => {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.showChangePasswordDialog = true;
          }
        },
        { title: 'login.logout', action: this.logout, color: 'error' }
      ];
    },
    showChangePasswordDialog: {
      get() {
        return this.getQueryParam(this.queryParam.CHANGE_PASSWORD);
      },
      set(value) {
        this.setQueryParam(this.queryParam.CHANGE_PASSWORD, value);
      }
    }
  },

  methods: {
    ...mapActions(['reset']),

    closeMenu() {
      this.menu = false;
    }
  }
};
</script>
